import { render, staticRenderFns } from "./businessDesc.vue?vue&type=template&id=6f1b8c9a&"
import script from "./businessDesc.vue?vue&type=script&lang=js&"
export * from "./businessDesc.vue?vue&type=script&lang=js&"
import style0 from "./businessDesc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports